const FREE_GIFT_OVER_PRICE = 6900;
const SELECTOR = '#CartDrawer .drawer_messages';
const START_DATE_TIME = '2024-11-04 09:30:00';
const END_DATE_TIME = '2024-11-12 23:59:59';
const EXCLUDE_PRODUCTS = [
  9186351776070, //Adventskalender
];
const HIDE_MESSAGE_IF_EXCLUDED_PRODUCT_IN_CART = true;
const PRODUCTS = [
  // {
  //   title: 'Schmucketui',
  //   handle: '/heideman-schmuck-etui',
  //   variants: {
  //     Default: 46855592902982,
  //   },
  // },
  {
    title: 'Surprise-Gift',
    handle: '/surprise-gift',
    variants: {
      Default: 48628374798662,
      Gold: 48628374798662,
      Silber: 48628374831430,
      Rose: 48628374864198,
    },
  },
];

document.addEventListener('DOMContentLoaded', () => {
  init();
});

document.addEventListener('shopify-additional-cart-items:cart-changed', () => {
  console.log('[Shopify Additional-Cart-Items] Cart changed ✅');

  updateHTML();
});

function init() {
  if (!isBetweenDatetime(START_DATE_TIME, END_DATE_TIME)) {
    return;
  }
  observeCartChanges();
  updateHTML();
  console.log('[Shopify Additional-Cart-Items] Additional-Cart-Items initialized ✅');
}

async function updateHTML() {
  const cart = await getCart();
  const remaining_money = toMoney(FREE_GIFT_OVER_PRICE - (cart.total_price - getExcludedProductsAmount(cart)));
  var additional_cart_items = document.querySelector('.h-additional-cart-items');

  if (document.contains(additional_cart_items)) {
    additional_cart_items.remove();
  }

  var wrapper = document.createElement('div');
  wrapper.classList.add('h-additional-cart-items');
  var element = document.querySelector(SELECTOR).appendChild(wrapper);

  html = `
        <p class="bg-[#d6ece2] p-[1rem] mb-[2rem]">
            &#128640; <strong>Fast geschafft!</strong> Dir fehlen noch <strong>${remaining_money}</strong> für deinen Gratisartikel.*
        </p>
    `;

  if (await cartAmountIsOver(FREE_GIFT_OVER_PRICE)) {
    html = `
            <p class="bg-[#d6ece2] p-[1rem] mb-[2rem]">
                &#127873; <strong>Yeah</strong>, hier ist dein Gratisartikel. Klicke jetzt auf den Button!
            </p>
            <div class="flex mb-[2rem] space-x-5">
                ${await generateButtons()}
            </div>
        `;
  }

  html = `
            <p class="bg-[#d6ece2] py-[1rem] px-[1.6rem] mb-[2rem]">
                🎁 Wähle deinen Singles-Week Rabatt!
            </p>
            <div class="flex mb-[2rem] px-[1.6rem] space-x-5">
                <a href="/discount/3FOR2" class="w-full bg-black uppercase border border-black text-white font-bold text-center px-[1rem] py-[0.8rem] rounded">3FOR2</a>
                <a href="/discount/EXTRA20" class="w-full bg-black uppercase border border-black text-white font-bold text-center px-[1rem] py-[0.8rem] rounded">EXTRA20</a>
                ${await generateButtons()}
            </div>
        `;

  if (containsExcludedProductsInCart(cart) && HIDE_MESSAGE_IF_EXCLUDED_PRODUCT_IN_CART == true) {
    html = '';
  }

  element.insertAdjacentHTML('beforeend', html);
}

async function generateButtons() {
  var html = '';

  for (const product of PRODUCTS) {
    const variant = await getPreferredVariant(product.variants);
    html += `
        <product-form class="product-form grow">
            <form method="post" action="/cart/add">
                <input type="hidden" name="id" value="${variant}" />
                <button type="submit" class="h-add-to-cart w-full bg-black uppercase border border-black text-white font-bold text-center px-[1rem] py-[0.8rem] rounded">
                    GIFT
                    <div class="loading-overlay__spinner hidden">
                    <svg
                        aria-hidden="true"
                        focusable="false"
                        class="spinner"
                        viewBox="0 0 66 66"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                    </div>
                </button>
            </form>
        </product-form>
    `;
  }

  return html;
}

function mode(arr) {
  return arr
    .slice()
    .sort((a, b) => arr.filter((v) => v === a).length - arr.filter((v) => v === b).length)
    .pop();
}
function colors(items) {
  return items
    .map((item) => item.options_with_values.find((c) => c.name == 'Color'))
    .filter((e) => e !== undefined)
    .map((e) => e.value);
}

function observeCartChanges() {
  const cartObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
      const isCartChangeRequest = /\/cart\//.test(entry.name);
      if (isValidRequestType && isCartChangeRequest) {
        const event = new CustomEvent('shopify-additional-cart-items:cart-changed');
        document.dispatchEvent(event);
      }
    });
  });
  cartObserver.observe({ entryTypes: ['resource'] });
}

async function getCart() {
  var opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch('/cart.js', opts);
  return response.json();
}

async function getPreferredVariant(variants) {
  const cart = await getCart();
  var cartItems = cart.items;
  var cart_colors = colors(cartItems);
  var preferred_color = mode(cart_colors);
  variant_id = variants[preferred_color];

  if (variant_id === undefined) {
    variant_id = variants['Default'];
  }

  return variant_id;
}

async function cartAmountIsOver(value) {
  const cart = await getCart();
  if (cart.total_price - getExcludedProductsAmount(cart) >= value) {
    return true;
  }
  return false;
}

function isBetweenDatetime(start_date_time, end_date_time) {
  if (new Date() > new Date(start_date_time) && new Date() < new Date(end_date_time)) {
    return true;
  }
  return false;
}

function toMoney(amount) {
  const locale = window.Shopify.locale;
  const country = window.Shopify.country;
  const currencyCode = window.Shopify.currency.active;

  return new Intl.NumberFormat(`${locale}-${country}`, {
    style: 'currency',
    currency: currencyCode,
  }).format(amount / 100);
}

function getExcludedProductsAmount(cart) {
  if (!cart) {
    return 0;
  }

  const price = cart.items.reduce((accumulator, object) => {
    return EXCLUDE_PRODUCTS.includes(object.product_id) ? accumulator + object.final_line_price : accumulator + 0;
  }, 0);
  return price;
}

function containsExcludedProductsInCart(cart) {
  if (!cart) {
    return false;
  }

  return cart.items.some((r) => EXCLUDE_PRODUCTS.includes(r.product_id));
}
